import perLocationList from '../../assets/clients-list.json';
export const clientsList = {
    'clients-list': perLocationList
}



// WEBPACK FOOTER //
// ./src/store/modules/clients-list.js